import { useContext } from 'react';
import AppContext from '../../../AppContext';
import { DollarFormat, RatioFormat } from '../../format';
import MedicalLossRatioSCHERowData from './MedicalLossRatioSCHERowData';
import RowHelmet from '../RowHelmet';
import styles from './MedicalLossRatioSCHERow.module.css';
import { DataResult } from '../../model/DataResult';

function hasAnyOutsideBenchmarks(
  preliminaryMLRCurrentYear: DataResult,
  preliminaryPointChange: DataResult,
  underwritingMLRCurrentYear: DataResult
) {
  return (
    preliminaryMLRCurrentYear?.outsideBenchmark ||
    preliminaryPointChange?.outsideBenchmark ||
    underwritingMLRCurrentYear?.outsideBenchmark
  );
}

export default function MedicalLossRatioSCHERow({
  sectionKey,
  rowKey,
  rowKeys,
  label,
  benchmark,
  preliminaryPointChange,
  preliminaryMLRCurrentYear,
  preliminaryMLRPriorYear,
  underwritingMLRCurrentYear,
  underwritingMLRPriorYear,
  underwritingPointChange,
  rowDisplay
}: MedicalLossRatioSCHERowData) {
  const { showBenchmark, riskRepository } = useContext(AppContext);
  const id = `${sectionKey}-${rowKeys[0] || rowKey}`;
  const isGrey = getDataDisplayType(rowDisplay, riskRepository);
  return (
    <div
      id={id}
      data-testid={id}
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse} ${
        !isGrey ? '' : styles.grey
      }`}>
      <RowHelmet
        label={label}
        isOutsideBenchmark={hasAnyOutsideBenchmarks(
          preliminaryMLRCurrentYear,
          preliminaryPointChange,
          underwritingMLRCurrentYear
        )}
        benchmarkText={benchmark}
      />
      <p></p>
      <p></p>
      <DollarFormat {...preliminaryPointChange} />
      <RatioFormat {...preliminaryMLRCurrentYear} showDefaultValue={true} />
      <RatioFormat {...preliminaryMLRPriorYear} />
      <DollarFormat {...underwritingPointChange} />
      <DollarFormat {...underwritingMLRCurrentYear} />
      <DollarFormat {...underwritingMLRPriorYear} />
    </div>
  );
}

function getDataDisplayType(
  rowDisplay:
    | {
        cr: string;
        lg: string;
        lq: string;
        mk: string;
        op: string;
        pu: string;
        rp: string;
        rv: string;
        st: string;
        fs: string;
      }
    | undefined,
  riskRepository: any
) {
  if (riskRepository === 'FR' || !rowDisplay) {
    return false;
  }
  if (
    riskRepository &&
    rowDisplay[riskRepository.toLowerCase() as keyof typeof rowDisplay] === 'GREY'
  ) {
    return true;
  }
}
